import React from "react";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { EmailSettings, useEmailSettings } from "../../components/superorg/settings/EmailSettings";
import { PageHeader } from "../../components/layout/header/Header";
import { RequestInboxTabs } from "./RequestListingPage";

export function PrivacyCenterDetailEmailPage() {
  const { settings } = useEmailSettings();

  return (
    <StandardPageWrapper fullWidth>
      <PageHeader titleContent="Request Inbox" />

      <div style={{ maxWidth: "1214px", paddingRight: "32px" }}>
        <div className="tw-boundary">
          <div className="flex justify-between items-end mb-6">
            <RequestInboxTabs selectedTabKey="email-settings" />
          </div>
        </div>

        <div className="privacy-center-settings" style={{ marginTop: "48px" }}>
          <EmailSettings {...settings} />
        </div>
      </div>
    </StandardPageWrapper>
  );
}
